(() => {
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-gh-toast-close]')) document.querySelector('.gh-toast').hidden = true;
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.gh-quick-add');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    button.disabled = true;
    const toast = document.querySelector('.gh-toast');
    const message = toast.querySelector('[data-gh-toast-message]');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || window.greenHavenText.cartError);
      const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-gh-cart-count]').forEach((badge) => { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; });
      }
      message.textContent = window.greenHavenText.added;
    } catch (error) {
      message.textContent = error.message || window.greenHavenText.cartError;
    } finally {
      toast.hidden = false;
      button.disabled = false;
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.gh-nav__dropdown[open], .gh-mobile-nav[open]').forEach((menu) => { menu.open = false; menu.querySelector('summary').focus(); });
  });
})();
